/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BancaDTO } from './BancaDTO';
import {
    BancaDTOFromJSON,
    BancaDTOFromJSONTyped,
    BancaDTOToJSON,
} from './BancaDTO';

/**
 * 
 * @export
 * @interface MacelloDTO
 */
export interface MacelloDTO {
    /**
     * 
     * @type {number}
     * @memberof MacelloDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof MacelloDTO
     */
    ragioneSociale?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MacelloDTO
     */
    cognome?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MacelloDTO
     */
    nome?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MacelloDTO
     */
    indirizzo?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MacelloDTO
     */
    numeroCivico?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MacelloDTO
     */
    cap?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MacelloDTO
     */
    localita?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MacelloDTO
     */
    provincia?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MacelloDTO
     */
    idNazione?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MacelloDTO
     */
    partitaIva?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MacelloDTO
     */
    codiceFiscale?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MacelloDTO
     */
    sdi?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MacelloDTO
     */
    email?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MacelloDTO
     */
    attivo?: boolean;
    /**
     * 
     * @type {BancaDTO}
     * @memberof MacelloDTO
     */
    banca?: BancaDTO;
}

/**
 * Check if a given object implements the MacelloDTO interface.
 */
export function instanceOfMacelloDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MacelloDTOFromJSON(json: any): MacelloDTO {
    return MacelloDTOFromJSONTyped(json, false);
}

export function MacelloDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): MacelloDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'ragioneSociale': !exists(json, 'ragioneSociale') ? undefined : json['ragioneSociale'],
        'cognome': !exists(json, 'cognome') ? undefined : json['cognome'],
        'nome': !exists(json, 'nome') ? undefined : json['nome'],
        'indirizzo': !exists(json, 'indirizzo') ? undefined : json['indirizzo'],
        'numeroCivico': !exists(json, 'numeroCivico') ? undefined : json['numeroCivico'],
        'cap': !exists(json, 'cap') ? undefined : json['cap'],
        'localita': !exists(json, 'localita') ? undefined : json['localita'],
        'provincia': !exists(json, 'provincia') ? undefined : json['provincia'],
        'idNazione': !exists(json, 'idNazione') ? undefined : json['idNazione'],
        'partitaIva': !exists(json, 'partitaIva') ? undefined : json['partitaIva'],
        'codiceFiscale': !exists(json, 'codiceFiscale') ? undefined : json['codiceFiscale'],
        'sdi': !exists(json, 'sdi') ? undefined : json['sdi'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'attivo': !exists(json, 'attivo') ? undefined : json['attivo'],
        'banca': !exists(json, 'banca') ? undefined : BancaDTOFromJSON(json['banca']),
    };
}

export function MacelloDTOToJSON(value?: MacelloDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'ragioneSociale': value.ragioneSociale,
        'cognome': value.cognome,
        'nome': value.nome,
        'indirizzo': value.indirizzo,
        'numeroCivico': value.numeroCivico,
        'cap': value.cap,
        'localita': value.localita,
        'provincia': value.provincia,
        'idNazione': value.idNazione,
        'partitaIva': value.partitaIva,
        'codiceFiscale': value.codiceFiscale,
        'sdi': value.sdi,
        'email': value.email,
        'attivo': value.attivo,
        'banca': BancaDTOToJSON(value.banca),
    };
}

